export const PANEL_NURSE = "nurse";
export const PANEL_DOCTOR = "doctor";
export const PANEL_SUPERADMIN = "superadmin";
